import { useEffect, useState } from 'react';

const useDimensions = () => {
  const [dimensions, setDimensions] = useState({ Width: window.innerWidth, Height: window.innerHeight });

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return function cleanup() {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    setDimensions({
      Width: window.innerWidth,
      Height: window.innerHeight
    });
  }

  return dimensions;
}

export default useDimensions;